import React from 'react';
import classNames from 'classnames';

import compose from '../../../../../lib/utils/compose';

import { IWithTPAProps, withTPA } from '../../../../../components/context/tpa';
import {
  withI18n,
  IWithI18nProps,
} from '../../../../../components/context/i18n';
import {
  withSettings,
  IWithSettingsProps,
} from '../../../../../components/context/settings/index';

import { Button } from '../../../../../components/ui/buttons/index';

import getStyles from './EpisodesLoadMore.styles';
import styles from './EpisodesLoadMore.scss';

interface IEpisodesLoadMoreProps
  extends IWithTPAProps,
    IWithI18nProps,
    IWithSettingsProps {
  isLoading: boolean;
  onLoadMore: Function;
}

function EpisodesLoadMore({
  isLoading,
  onLoadMore,
  tpa,
  settings,
  t,
}: IEpisodesLoadMoreProps) {
  const dynamicStyles = getStyles({
    buttonStyle: settings.common.buttonStyle,
    deviceType: tpa.params.deviceType,
    colors: settings.colors,
  });

  return (
    <div className={styles.loadMoreContainer}>
      <Button
        className={classNames(
          styles.loadMoreButton,
          dynamicStyles.loadMoreButton,
        )}
        onClick={onLoadMore}
        disabled={isLoading}
      >
        {t('pages.main.episodes-load-more')}
      </Button>
    </div>
  );
}

export default compose(withTPA, withSettings, withI18n)(EpisodesLoadMore);
